import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=0e43c2ef&"
import script from "./OtherSettings.vue?vue&type=script&lang=js&"
export * from "./OtherSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports